<script>
    export let value = "";

    import { getContext } from "svelte";
    import { api_info, listOrganization } from "../api/client.js";
    import Select from "svelte-select";

    const context = getContext(api_info);
    async function getOrganization() {
        const response = await listOrganization(context, {});
        return response.organizations.map((x) => ({
            value: x.name,
            label: x.name,
        }));
    }

    let organizations = getOrganization();

    function handleSelect(event) {
        value = event.detail.value;
    }
</script>

{#await organizations then organizations}
    <Select
        class="form-control"
        items={organizations}
        {value}
        on:select={handleSelect}
        isClearable={false}
        {...$$restProps}
    />
{/await}
